module.exports = __webpack_public_path__ + "img/face1.90a61a0b.jpg";